const firebaseConfig = {
  apiKey: "AIzaSyDB_12E0_gCDrj9Ofoi9VyWSI1HhSnFEYA",
  authDomain: "magna-3d0be.firebaseapp.com",
  databaseURL: "https://magna-3d0be.firebaseio.com",
  projectId: "magna-3d0be",
  storageBucket: "magna-3d0be.appspot.com",
  messagingSenderId: "206805306542",
  appId: "1:206805306542:web:f97e41210f64c4a479b13f",
  measurementId: "G-MC1SZTE2WN",
};

// Initialize Firebase
export default firebaseConfig;
